<div class="wrapper">
  <section>
    <div class="field-row">
      <app-view-field
        class="field-row"
        label="NAME"
        [value]="fullName"
        [supportingValue]="jobTitle"
        />
    </div>
    <div class="field-row">
      <app-view-field
        class="field-row"
        label="JOB CODE"
        [value]="jobTitle"
        />
    </div>

    <div class="bid-item-wrapper">
      <div class="field-row">
        <app-view-field
          label="BID ITEM"
          [value]="bidItem"
          />
      </div>
      <div class="time-row field-row">
        <app-view-field
          class="half-width"
          label="STANDARD TIME"
          [value]="data.standard_time"
          />
        <app-view-field
          class="half-width"
          label="OVER TIME"
          [value]="data.over_time"
          />
      </div>
    </div>
  </section>
  @if (data.pictures?.length) {
    <section
      class="attachments-section"
      >
      <app-attachments-block [pictures]="data.pictures"/>
    </section>
  }
</div>
